import { Redo2, Undo2 } from "lucide-react";
import { useDesign } from "../state/designStore";

export function UndoRedoBar() {
  const { undo, redo, canUndo, canRedo } = useDesign();
  const btn = (enabled: boolean) =>
    `w-9 h-9 rounded-full flex items-center justify-center transition-opacity ${enabled ? "active:bg-white/10" : "opacity-30"}`;
  return (
    <div className="flex items-center">
      <button type="button" aria-label="تراجع" disabled={!canUndo} onClick={undo} className={btn(canUndo)}>
        <Undo2 size={19} strokeWidth={2.25} />
      </button>
      <button type="button" aria-label="إعادة" disabled={!canRedo} onClick={redo} className={btn(canRedo)}>
        <Redo2 size={19} strokeWidth={2.25} />
      </button>
    </div>
  );
}
